module.exports = __webpack_public_path__ + "static/media/logo.7bf641f4.png";